export default __webpack_public_path__ + "static/avatar-mp-kayi-female-0-v2-ed3453a43e25562b2fc080d78f2d43b0.png";